export const userAccess = {
  computed: {
    entities () {
      return ['item', 'item_group']
    },
    adminEntities () {
      return [...this.entities, 'key', 'key_value']
    },
    userRoles () {
      return this.$auth.userRoles || []
    },
    userPermissions () {
      return this.$auth.permissions || []
    },
    userRelatedParties () {
      return this.$store.getters.userRelatedParties
    },
    userDCs () {
      return this.getUserPartiesByType('DISTRIBUTION_CENTER')
    },
    userStores () {
      if (this.isAdmin) return this.$store.getters.stores
      const stores = this.getUserPartiesByType('STORE')
      if (stores.length > 0) {
        return stores.map(store => {
          const storeNumber = store.attributes ? store.attributes.WHOLESALER_STORE_NUMBER : ''
          const displayName = `#${storeNumber} ${store.name}`
          return { ...store, name: displayName }
        })
      }
      return []
    },
    sources () {
      return this.$store.getters.sources
    },
    partySourceRelationships () {
      return this.$store.getters.partySourceRelationships
    },
    userSources() {
      let sources = this.sources
      if (this.limitAccessByRelatedSources) {
        const userDcIds = this.userDCs.flatMap(p => p ? p.id : [])
        let partySourceRelationshipIds = this.partySourceRelationships.reduce((acc, psr) => {
          if (psr && userDcIds.includes(psr.party_id)) {
            acc.push(psr.source_id)
          }
          return acc
        }, [])
        sources = sources.filter(source => partySourceRelationshipIds.includes(source.source_id))
      }
      return sources
    },
    userVendors () {
      return this.getUserPartiesByType('VENDOR')
    },
    userVendorIds () {
      return this.userVendors.flatMap(v => v ? v.attributes.VENDOR_ID : [])
    },
    hasPortalAccess () {
      if (this.userPermissions.includes('item:no_access') || ((this.$auth.tenant === 'alliance-retail-group') && (process.env.NODE_ENV === 'production') && this.noProdAccess)) {
        return false
      }
      const readScopes = this.entities.map(entity => `${entity}:read`)
      return readScopes.every(scope => this.userPermissions.includes(scope))
    },
    userAccessiblePortals() {
      const portals = ['ad_planner', 'customer', 'promo', 'item', 'billing', 'tpr', 'partner']
      const isProd = process.env.NODE_ENV === 'production'

      return portals.filter(portal => {
        let readScope = `${portal}:read`
        if (portal === 'billing') {
          readScope = 'billing_batch:read'
        } else if (portal === 'customer') {
          readScope = 'party:read'
        } else if (portal === 'tpr') {
          readScope = 'tpr_batch:read'
        } else if (portal === 'partner') {
          readScope = 'document:read'
        }
        const canRead = this.userPermissions.includes(readScope)
        if (!canRead) return false

        // Hard deny in all envs
        if (this.userPermissions.includes(`${portal}:no_access`)) return false

        // Deny in prod only (dev allowed) if they have the prod-block flag
        if (isProd && this.userPermissions.includes(`${portal}:no_access_prod`)) return false

        return true
      })
    },
    hasWriteAccess () {
      return this.writePermissions.every(scope => this.userPermissions.includes(scope))
    },
    writePermissions () {
      const actions = ['create', 'read', 'update']
      return this.$auth.buildScopes(this.entities, actions)
    },
    isAdmin () {
      return this.$auth.isAdmin
    },
    isRetailer () {
      return (this.$auth.tenant === 'jbg') && !this.isAdmin && this.userRoles.includes('jbg-retailer')
    },
    isProductCatalogRetailer () {
      return this.isRetailer && this.userStores.some(store => {
        return (store && store.attributes && store.attributes.PRODUCT_CATALOG_STORE === 'True')
      })
    },
    hasDsdUploadAccess () {
      return this.$auth.tenant === 'awg' || (this.$auth.tenant === 'alliance-retail-group' && (this.isAdmin || this.userPermissions.includes('item:dsd_upload')))
    },
    noProdAccess() {
      return this.userPermissions.includes('item:no_access_prod')
    }, 
    hasUpdateMultipleAccess () {
      return this.isAdmin || (this.hasWriteAccess && this.userPermissions.includes('item:update_multiple'))
    },
    limitAccessByRelatedSources () {
      return !this.isAdmin && this.userPermissions.includes('item:related_sources')
    },
    limitAccessByRelatedVendors () {
      return !this.isAdmin && this.userPermissions.includes('item:related_vendors')
    },
    retailerCatalog () {
      if (this.isRetailer && this.userStores.length > 0) {
        const store = this.userStores[0]
        const { STORE_PRICE_LIST, STORE_PRICE_MARKUP, STORE_PRICE_ZONE, STORE_PRICE_MARGIN } = store.attributes
        const catalog_name = [
          STORE_PRICE_LIST,
          STORE_PRICE_MARKUP, 
          (STORE_PRICE_ZONE || ''),
          (STORE_PRICE_MARGIN || '')
        ].join('')
        return catalog_name
      }
      return ''
    }
  },
  methods: {
    getUserPartiesByType (partyType) {
      return this.userRelatedParties.filter(party => {
        return party && party.party_type_constant === partyType
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/user-access.js